module.exports = __webpack_public_path__ + "img/abc-color-site.jpg";